import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IGroupResponse, IGroupState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowGroup = createAsyncThunk('listGroups/fetchShowGroup', async (id: string, { rejectWithValue }) => {
  try {
    const response = await adminApiClient.getGroup(id)
    return response.data
  } catch (error: any) {
    if (!error.response) {
      throw error
    }

    return rejectWithValue(error)
  }
})

const initialState: IGroupState = {
  isLoading: false,
  response: null,
  error: null
}

const showGroupSlice = createSlice({
  name: 'groups/show',
  initialState,
  reducers: {
    resetShowGroup: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowGroup.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowGroup.fulfilled, (state, action: PayloadAction<IGroupResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowGroup.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showGroupSlice.reducer
export const { resetShowGroup } = showGroupSlice.actions
